import {inject, Injectable, Injector} from '@angular/core';
import {ObjectService} from './object.service.abstract';
import {ChatbotsService} from "../../chatbots.service";
import {AssistantsService} from "../../assistants.service";
import {WorkflowsService} from "../../workflows.service";
import {FunctionsService} from "../../functions.service";
import {FilesService} from "../../files.service";
import {TasksService} from "../../tasks.service";
import {ProductFeedService} from "../../product-feed.service";

@Injectable({
    providedIn: 'root',
})
export class ObjectServiceFactory {
    private injector = inject(Injector);


    getService(type: string): ObjectService<any> {
        switch (type.toLowerCase()) {
            case 'chatbots':
                return this.injector.get(ChatbotsService);
            case 'assistants':
                return this.injector.get(AssistantsService);
            case 'workflows':
                return this.injector.get(WorkflowsService);
            case 'functions':
                return this.injector.get(FunctionsService);
            case 'files':
                return this.injector.get(FilesService);
            case 'tasks':
                return this.injector.get(TasksService);
            case 'product-feeds':
                return this.injector.get(ProductFeedService);
            default:
                throw new Error(`No service found for object type: ${type}`);
        }
    }
}
